export const ASCENDING = 'Ascending';
export const DESCENDING = 'Descending';
